import request from '@/services/interceptor.js'

// ─── Form ordine (usano sempre l'aziendaId del token) ────────────────────────

/**
 * Recupera tutte le opzioni per le select del form ordine.
 * L'aziendaId viene letto dal token JWT lato server.
 */
export const get_opzioni = () => {
    return request({
        url: '/parametri/opzioni',
        method: 'get',
        loadingBar: true
    })
}

/**
 * Recupera le opzioni per una specifica categoria.
 * @param {string} categoria - Codice categoria (es: 'essenze', 'serie', ecc.)
 */
export const get_opzioni_by_categoria = (categoria) => {
    return request({
        url: `/parametri/opzioni/${categoria}`,
        method: 'get',
        loadingBar: false
    })
}

/**
 * Recupera l'elenco delle categorie attive.
 */
export const get_categorie = () => {
    return request({
        url: '/parametri/categorie',
        method: 'get',
        loadingBar: true
    })
}

// ─── Gestione admin ───────────────────────────────────────────────────────────

/**
 * Recupera l'elenco delle aziende (solo super admin, per il selettore).
 */
export const get_aziende = () => {
    return request({
        url: '/parametri/admin/aziende',
        method: 'get',
        loadingBar: true
    })
}

/**
 * Recupera tutti i valori (attivi e non) di una categoria per la gestione admin.
 * @param {number} categoriaId
 * @param {number|null} aziendaId - null = valori globali (solo super admin)
 */
export const get_valori_admin = (categoriaId, aziendaId = undefined) => {
    return request({
        url: `/parametri/admin/valori/${categoriaId}`,
        method: 'get',
        params: aziendaId !== undefined ? { aziendaId } : {},
        loadingBar: true
    })
}

/**
 * Crea un nuovo valore in una categoria.
 * @param {number} categoriaId
 * @param {{ value: string, label: string, ordinamento: number }} data
 * @param {number|null} aziendaId - null = globale (solo super admin)
 */
export const crea_valore = (categoriaId, data, aziendaId = undefined) => {
    return request({
        url: `/parametri/admin/valori/${categoriaId}`,
        method: 'post',
        data,
        params: aziendaId !== undefined ? { aziendaId } : {},
        loadingBar: true
    })
}

/**
 * Modifica un valore esistente.
 * @param {number} valoreId
 * @param {{ value: string, label: string, ordinamento: number }} data
 * @param {number|null} aziendaId
 */
export const modifica_valore = (valoreId, data, aziendaId = undefined) => {
    return request({
        url: `/parametri/admin/valori/${valoreId}`,
        method: 'put',
        data,
        params: aziendaId !== undefined ? { aziendaId } : {},
        loadingBar: true
    })
}

/**
 * Soft-delete di un valore (Attivo = 0).
 * @param {number} valoreId
 * @param {number|null} aziendaId
 */
export const elimina_valore = (valoreId, aziendaId = undefined) => {
    return request({
        url: `/parametri/admin/valori/${valoreId}`,
        method: 'delete',
        params: aziendaId !== undefined ? { aziendaId } : {},
        loadingBar: true
    })
}

/**
 * Aggiorna l'ordinamento di una lista di valori in bulk.
 * @param {Array<{ id: number, ordinamento: number }>} valori
 * @param {number|null} aziendaId
 */
export const aggiorna_ordinamento = (valori, aziendaId = undefined) => {
    return request({
        url: `/parametri/admin/valori/ordinamento`,
        method: 'put',
        data: valori,
        params: aziendaId !== undefined ? { aziendaId } : {},
        loadingBar: true
    })
}

/**
 * Copia i valori globali per una nuova azienda (solo super admin).
 * @param {number} aziendaId
 */
export const copia_valori_globali = (aziendaId) => {
    return request({
        url: `/parametri/admin/aziende/${aziendaId}/copia-globali`,
        method: 'post',
        loadingBar: true
    })
}